import { useState, useEffect } from "react"
import {
    Grid,
    AppBar,
    Tabs,
    Tab,
} from "@material-ui/core"
import EventIcon from '@material-ui/icons/Event';
import ReceiptIcon from "@material-ui/icons/Receipt"
import HomePage from "../../Home"
import { Container } from "@material-ui/core"
import TLiquidaciones from "../TLiquidaciones"
import TLiquidacionesAuth from "../TLiquidacionesAuth";
import { useDispatch } from "react-redux"
import { obtenerliquidacionesAction } from "../../../ducks/liquidacionesDuck"
import { obtenerliquidacionesAuthAction } from "../../../ducks/liquidacionesAuthDuck"
import FiltroLiquidacionesAuth from "./../FiltroLiquidacionesAuth"
import FiltroLiquidaciones from "../FiltroLiquidaciones";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    {children}
                </div>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}
const VAereo = () => {
    const [value, setValue] = useState(0)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({message: "Obteniendo Liquidaciones..."}))
        dispatch(obtenerliquidacionesAction()).then(Response =>{ 
            dispatch(offLoadAction())
        })
        dispatch(obtenerliquidacionesAuthAction())
    },[dispatch])
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    return (
        <HomePage>
            <Container maxWidth="xl">
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Liquidaciones</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <AppBar position="static" color="secondary">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="on"
                                indicatorColor="primary"
                                aria-label="scrollable force tabs example"
                            >
                                <Tab
                                    label="Pendientes"
                                    icon={<EventIcon />}
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label="Autorizados"
                                    icon={<ReceiptIcon />}
                                    {...a11yProps(1)}
                                />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                            <FiltroLiquidaciones />
                            <TLiquidaciones />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <FiltroLiquidacionesAuth/>
                            <TLiquidacionesAuth/>
                        </TabPanel>
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VAereo